import React, { useState } from 'react'
import { Alert, Card, Spinner } from 'react-bootstrap'

import Camera from 'react-html5-camera-photo'
import 'react-html5-camera-photo/build/css/index.css'

import userFrame from './../../assets/images/user-frame.svg'

import { BASE } from '../../basedata/constants'
import { fetchWithApiKey } from '../../config/apiCall'
import { getCompanyBrandName } from '../../config/session'

interface Props {
  onResponse: (response: any) => void
}

const TakeFoto = ({ onResponse }: Props) => {
  const clubBrandName = getCompanyBrandName()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [statusMessage, setStatusMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  async function handleTakePhoto(dataUri: any) {
    if (isSubmitting) {
      return
    }

    const contingencyReasonId = sessionStorage.getItem('contingencyReasonId')
    const ticketNumber = sessionStorage.getItem('ticket')
    const token = sessionStorage.getItem('token')
    const gameCode = sessionStorage.getItem('gameCode')
    const gameId = sessionStorage.getItem('gameId')
    const gate = sessionStorage.getItem('ingPortao')
    const sectorId = sessionStorage.getItem('sectorId')
    const row = sessionStorage.getItem('row')
    const seat = sessionStorage.getItem('seat')
    const document = sessionStorage.getItem('document')
    const tokenBiometric = sessionStorage.getItem('tokenBiometric')
    const parsedContingencyReasonId = Number(contingencyReasonId)
    const hasContingencyReasonId = Number.isInteger(parsedContingencyReasonId)
      && parsedContingencyReasonId > 0

    setErrorMessage('')
    setIsSubmitting(true)
    setStatusMessage('Foto capturada. Validando e enviando, isso pode levar alguns instantes.')

    try {
      const res = await fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.generateLog}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ticket: ticketNumber,
          operator: token,
          qrCode: ticketNumber,
          imageBase64: dataUri,
          ...(hasContingencyReasonId
            ? { contingencyReasonId: parsedContingencyReasonId }
            : {}),
          gameCode: gameCode || '00000',
          gameId: gameId || '',
          gate: gate || '-',
          sectorId: sectorId || '-',
          row: row || '-',
          seat: seat || '-',
          document: document || '-',
          tokenBiometric: tokenBiometric || '-'
        })
      })

      const response = await res.json().catch(() => ({}))

      if (!res.ok || response?.error) {
        throw new Error(response?.message || response?.error || 'Falha ao validar a foto.')
      }

      sessionStorage.removeItem('contingencyReasonId')
      sessionStorage.removeItem('gameCode')
      setStatusMessage('Validação concluída. Redirecionando...')
      onResponse(2)
    } catch (error) {
      console.error('Erro ao gerar acesso por foto:', error)
      setErrorMessage('Não foi possível concluir a validação da foto agora. Confira a câmera e tente novamente.')
      setStatusMessage('')
      setIsSubmitting(false)
    }
  }

  return (
    <Card className='photo-flow-card'>
      <Card.Header>
        <Card.Title
          as='h5'
          onClick={() => {
            if (!isSubmitting) {
              onResponse(0)
            }
          }}
        >
          <i className='feather icon-arrow-left'></i> Voltar
        </Card.Title>
      </Card.Header>
      <Card.Body className='canvas-wrap photo-flow-body'>
        <div className='photo-flow-copy'>
          <h6>{clubBrandName} - validação por foto</h6>
          <p>
            Posicione o rosto dentro da moldura e mantenha o dispositivo estável.
            Após capturar, a análise pode levar alguns instantes.
          </p>
        </div>

        {statusMessage && (
          <Alert variant='info' className='photo-flow-feedback'>
            {statusMessage}
          </Alert>
        )}

        {errorMessage && (
          <Alert variant='danger' className='photo-flow-feedback'>
            {errorMessage}
          </Alert>
        )}

        <div className='camera-stage'>
          {isSubmitting && (
            <div className='camera-processing-overlay'>
              <Spinner animation='border' variant='light' />
              <strong>Processando foto</strong>
              <span>Aguarde. Não feche a tela nem tente capturar novamente.</span>
            </div>
          )}

          <div className='canvas-frame'>
            <img src={userFrame} alt='Moldura para captura facial' />
          </div>

          <Camera
            idealFacingMode='environment'
            onTakePhoto={(dataUri: any) => {
              handleTakePhoto(dataUri)
            }}
          />
        </div>

        {!isSubmitting && (
          <div className='photo-flow-tip'>
            Se a validação falhar, você poderá tirar outra foto em seguida.
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default TakeFoto
